<main class="fadeIn">
    <div class="container-fluid" #focusedElement>
        <div class="row">
            <div class="col-12">
                <div class="header d-flex justify-content-between">
                    <h1><small>&nbsp;</small>Allergy Code List</h1>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="filter-body">
                    <div class="filter">
                        <div class="row justify-content-between">
                            <div class="col-10" style="width:85%">

                                <div class="row" [formGroup]="allergyfilterForm">
                                    <div class="col-2">
                                        <input type="text" class="form-control" formControlName="version" id="MDSearch"
                                            placeholder="Search by version" appPreventFirstSpace>
                                    </div>
                                    <div class="col-3">
                                        <app-datepicker_v2 formControlName="validity" [field]="feild_startDate">
                                        </app-datepicker_v2>
                                    </div>
                                    <div class="col-2">
                                        <input autocomplete="disabled" class="form-check-input" formControlName="inUse"
                                            type="checkbox" id="inUse">
                                        <label class="form-check-label link" for="inUse">In Use</label>
                                    </div>
                                    <div class="col-2 d-flex">
                                        <button id="btnDrugFilterApply" type="button" class="btn btn-dark-blue"
                                            (click)="filterOnClick()">APPLY</button>
                                        <a class="reset-btn" (click)="resetFilter()"><span></span>Reset</a>
                                    </div>
                                </div>

                            </div>
                            <div class="col" *ngIf="checkPermission(permissions.allergy.saveAllergy)">
                                <button id="btnGroupAddNewDrugList" type="button" data-bs-toggle="modal"
                                    class="btn btn-primary float-end" (click)="addNewAlleryCode()">
                                    ADD New
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="table-container table-responsive">
                    <table class="table table-list">
                        <caption class="d-none"> table body</caption>
                        <thead>
                            <tr>
                                <th scope="col">Version
                                    <span class="sort-order" *ngIf="allergyCodeList?.length"
                                        (click)="sortColumn('allergyVersion')">
                                        <a class="{{columnSort['allergyVersion'].sortType}}"></a>
                                    </span>
                                </th>
                                <th scope="col">Validity<span *ngIf="allergyCodeList?.length" class="sort-order"
                                        (click)="sortColumn('activeFrom')"><a
                                            class="{{columnSort['activeFrom'].sortType}}"></a></span>
                                </th>
                                <th scope="col">Description<span *ngIf="allergyCodeList?.length" class="sort-order"
                                        (click)="sortColumn('allergyVersionDesc')"><a
                                            class="{{columnSort['allergyVersionDesc'].sortType}}"></a></span>
                                </th>
                                <th scope="col">Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of allergyCodeList">
                                <td>{{item.allergyVersion}}</td>
                                <td>{{item?.activeFrom | dateFormat}} - {{item?.expiredOn| dateFormat}}
                                </td>
                                <td>{{ item?.allergyVersionDesc || '-'}} </td>
                                <td>
                                    <ul class="actions">

                                        <li>
                                            <a data-bs-toggle="modal" class="edit-icon tool-wrap position-relative"
                                                (click)="showEdit(item)" *ngIf="checkPermission(permissions.allergy.editAllergy)">
                                                <div class="custom-tooltip tooltip-top" role="tooltip">
                                                    <div class="arrow"></div>
                                                    <div class="tooltip-inner"> Edit </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a data-bs-toggle="modal" class="view tool-wrap position-relative"
                                                (click)="ShowDetailView(item)" *ngIf="checkPermission(permissions.allergy.getAllergyDetails)">
                                                <div class="custom-tooltip tooltip-top" role="tooltip">
                                                    <div class="arrow"></div>
                                                    <div class="tooltip-inner"> View </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data with-border" *ngIf="!allergyCodeList?.length">
                        <img src="./assets/images/icons/no-data-img.svg" alt="">
                        <p>No Results Found</p>
                    </div>
                </div>
                <app-navigation [listLength]="totalCount" [pageNo]="page_no"
                    (currentPageDetail)="currentPageDetail($event)">
                </app-navigation>
            </div>
        </div>
    </div>
</main>
<app-master-add-edit *ngIf="isAddpage" [isEdit]="isEdit" (closeAddEdit)="closeAddEdit($event)" [screenType]="'allergy'"
    [selectedVersion]="selectedVersion"></app-master-add-edit>